import { defineComponent } from 'vue'
import { useI18n } from '../i18n-shim';
import { i18nWithLink } from '@/eSign-i18n';

export default defineComponent({
  name: 'LocalizedInfoSection',
  props: {
    sectionName: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      i18nWithLink,
      assetUrl: (img: string): string | void => {
        if (img != null) {
          return new URL(`../assets/${img}.png`, import.meta.url).href;
        }
      },
      ...useI18n()
    }
  }
});
